import React, { useEffect, useState } from 'react';
import { GeckoModalService } from 'ui';
import { getFacebookScopePermissions } from '../../../../utilities/facebook';

function FacebookReauthenticateForm({ pageId }) {
  const [authToken, setAuthToken] = useState(null);
  const checkLoginState = () => {
    // If Facebook hasn't loaded yet wait for it to load
    if (!window.FB) {
      return setTimeout(checkLoginState, 200);
    }
    // Otherwise get an auth token and a list of pages
    window.FB.getLoginStatus((response) => {
      if (response.status === 'connected') {
        const auth_token = response.authResponse.accessToken;
        const userId = response.authResponse.userID;
        setAuthToken(auth_token);
        window.FB.api(`/${userId}/accounts`, (response) => {
          if (response.error) {
            // If the token is invalid null it so we get the login button again
            if (
              response.error.message ===
              'Error validating access token: The session is invalid because the user logged out.'
            ) {
              return setAuthToken(null);
            }
            return new GeckoModalService().close(
              new Error(response.error.message)
            );
          }
          const page = response.data.find((page) => page.id === pageId);
          if (Boolean(page)) {
            new GeckoModalService().close(auth_token);
          } else {
            new GeckoModalService().close(
              new Error(
                `Sorry, you don't have permission to re-authenticate this Facebook page. Ask your Facebook Page admin for the required permissions.`
              )
            );
          }
        });
      }
    });
  };
  useEffect(() => {
    checkLoginState();
  }, []);

  const loginToFacebook = () => {
    window.FB.login(checkLoginState, {
      scope: getFacebookScopePermissions(),
    });
  };

  return (
    <div className="FacebookReauthenticateForm">
      {authToken === null ? (
        <a
          className="btn btn-primary"
          style={{ display: 'block', color: 'white' }}
          onClick={loginToFacebook}
        >
          Login to Facebook
        </a>
      ) : (
        <p>Re-Authenticating...</p>
      )}
    </div>
  );
}

export default FacebookReauthenticateForm;
